export const articleNormalize = article => {
  if (!article) return '';
  return article.replace(/[^a-zA-Zа-яА-Я0-9]/g, "").toUpperCase();
};
